import { Intl } from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import React from 'react';
import { styled } from 'linaria/react';
import { css } from 'linaria';
import { BooleanFilters } from './BooleanFilters';
import { ListAccordion } from './Mobile/ListAccordion';
import { RangeAccordion } from './Mobile/RangeAccordion';
import { useFilters } from '@jetshop/core/hooks/Filters/useFilters';
import { ClearButton } from './ActiveFilters';
import t from '@jetshop/intl';
import Button from '../../ui/Button';
import { ReactComponent as Close } from '../../../svg/Close.svg';
import { theme } from '../../Theme';
import { ActiveFilters } from './ActiveFilters';

const Title = styled('h2')`
  line-height: 21px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.02em;
  color: ${theme.colors.black};
  svg {
    width: 19px;
    height: 14px;
    margin-right: 10px;
  }
`;

const Wrapper = styled('div')`
  padding: 0 40px;
  button {
    padding: 0 1rem;
    border-width: 1px 0 0 0;
  }
  .inner {
    padding-left: 20px;
    min-height: 75px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filterwrapper {
    padding: 0;
    padding-left: 20px;
    min-height: 50px;
    cursor: pointer;
  }
  .close {
    color: ${theme.colors.darkred};
  }

  ${theme.below.lg} {
    padding: 0 16px;
  }
`;

const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 1em;
  width: 100%;
  margin: auto;
  > button {
    width: 100%;
    margin: auto auto 20px auto;
    max-width: 392px;
    border-radius: 0;
    height: 36px;
    &.RED {
      height: 43px;
      border-radius: 5px;
      background: ${theme.colors.red};

      a,
      div {
        color: ${theme.colors.white};
      }
    }
  }
`;

const boolFilters = css`
  padding: 20px;
  label {
    margin-top: 0.5em;
  }
`;

const ActiveListFilterWrapper = styled('div')`
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  border-top: 1px solid ${theme.colors.border};
  margin: 0 40px;
  ${theme.below.lg} {
    margin: 0 16px;
  }
  button {
    margin-right: 10px;
    margin-bottom: 10px;
  }
`;

const EmptyDiv = styled('div')`
  border-top: 1px solid ${theme.colors.border};
  height: 140px;
  margin: 0 40px;

  ${theme.below.lg} {
    margin: 0 16px;
    height: 80px;
  }
`;

const BoolWrapper = styled('div')`
  border-top: 1px solid ${theme.colors.border};
`;

const FilterDrawer = ({
  filters,
  sortOrders,
  close,
  totalproducts,
  ...props
}) => {
  const { clearAllFilters } = useFilters();
  const isActiveListFilter = filters.some(listFilter => {
    return listFilter.hasActiveItems;
  });

  const listFilters = (filters || []).filter(
    filter => filter.__typename === 'ListFilter'
  );

  const rangeFilters = (filters || []).filter(
    filter => filter.__typename === 'NumericRangeFilter'
  );

  const isFilters = !!filters;
  const isSortOrders = sortOrders?.length > 0;

  return (
    <section {...props}>
      {(isFilters || isSortOrders) && (
        <>
          <Wrapper>
            <div className="inner">
              <Title>
                <Intl>{t => `${t('Filter')}`}</Intl>
              </Title>
              <div
                className="close"
                onClick={() => {
                  close();
                }}
              >
                <Close />
              </div>
            </div>
            <Accordion single>
              {accordionProps => (
                <>
                  {isFilters && (
                    <ListAccordion
                      filters={listFilters}
                      accordionProps={accordionProps}
                    />
                  )}
                </>
              )}
            </Accordion>
            <Accordion single>
              {accordionProps => (
                <>
                  {isFilters && (
                    <RangeAccordion
                      filters={rangeFilters}
                      accordionProps={accordionProps}
                      startingIdx={listFilters.length}
                    />
                  )}
                </>
              )}
            </Accordion>
            {isFilters && (
              <BoolWrapper>
                <div className={boolFilters}>
                  <BooleanFilters filters={filters} />
                </div>
              </BoolWrapper>
            )}
          </Wrapper>
          {/* }
                  {isSortOrders && (
                    <SortOrderAccordion
                      sortOrders={sortOrders}
                      accordionProps={accordionProps}x
                      startingIdx={listFilters.length + rangeFilters.length}
                    />
                  )} */}

          <EmptyDiv />

          <ActiveListFilterWrapper>
            <ActiveFilters filters={filters} />
          </ActiveListFilterWrapper>

          <ButtonContainer>
            {isActiveListFilter && (
              <ClearButton type="button" onClick={clearAllFilters}>
                {t('Clear all filters')}
              </ClearButton>
            )}
            <Button className="RED" onClick={close}>
              <span>
                {t(`See results`)} ({totalproducts})
              </span>
            </Button>
          </ButtonContainer>
        </>
      )}
    </section>
  );
};
export default FilterDrawer;
